module.exports = __webpack_public_path__ + "img/joinus.856fd732.png";